import { render, staticRenderFns } from "./ReUploadScanningCopyModal.vue?vue&type=template&id=56e378c6&scoped=true&"
import script from "./ReUploadScanningCopyModal.vue?vue&type=script&lang=js&"
export * from "./ReUploadScanningCopyModal.vue?vue&type=script&lang=js&"
import style0 from "./ReUploadScanningCopyModal.vue?vue&type=style&index=0&id=56e378c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e378c6",
  null
  
)

export default component.exports